/* eslint-disable no-console */
/* eslint-disable max-len */
import React, { useCallback, useContext, useEffect, useRef, useState } from 'react';
import { Box, IconButton, Stack, Typography } from '@mui/material';
import Draggable from 'react-draggable';
import { MdVideocam, MdCallEnd, MdVideocamOff, MdOutlineVideocam, MdOutlineVideocamOff, MdScreenShare } from 'react-icons/md';
import { LuMaximize } from 'react-icons/lu';
import { IoMdMicOff, IoMdMic } from 'react-icons/io';
import { CallContext, LanguageContext } from '../../../../../../../../libs/Context';
import { PRESENCE_ENUMS } from '../../../../../../../../libs/enums/presenceEnums';
import { useDispatch, useSelector } from 'react-redux';
import { setRoomModeView, setVideoCall } from '../../../../../../../../redux/CallsRedux';
import { callTimerFormat } from '../../../../../../../../libs/HelperContent';
import { toast } from 'react-toastify';
import { store } from '../../../../../../../../redux/store';
import { setCallDetails, setEachCallDetailChanges } from '../../../../../../../../redux/PresenceRedux';
import { updateDocByDocumentId } from '../../../../../../../../utils/Firebase/firebaseQuery';
import { config } from '../../../../../../../../libs/CallHelper';
import FullScreen from '../../FullScreen';
type DragState = {
	start: boolean;
	stop: boolean;
	drag: boolean;
  };

const PeerToPeerCall = (props:any) =>
{
	const { localStreamRef, pc, remoteStreamRef, reconectionRef } = props;
	const [ max, setMax ] = useState(false);
	const { language } = useContext(LanguageContext);
	const callDetails = useSelector((state:any) => state?.mypresence?.callDetails);
	const userData = useSelector((state:any) => state?.mysession?.session);
	const callData = useSelector((state:any) => state?.call);
	const { updateCallDetails, peerConnectionClose, handleAccept, updateCallCamera, handleAudioOff, setUpGroupCallInfo } = useContext(CallContext);
	const dispatch = useDispatch();
	const [ duration, setDuration ] = useState(0);
	const temporaryRef = useRef<MediaStream | null>(null);
	const onGoingCall = callDetails?.status === 'connected';
	const screenStreamRef = useRef<any>(null);
	const originalStreamRef = useRef<any>(null);
	const localVideoStreemRef = useRef<any>(null);
	const remoteVideoStreemRef = useRef<any>(null);

	const [ drag, setDrag ] = useState<DragState>({
		start : false,
		stop  : false,
		drag  : false
	});
	const dotCount = 3;

	const handleMaxScreen = () =>
	{
		setMax(!max);
	};
	const handleDragState = (key: keyof DragState) =>
	{
		setDrag((prev) => ({
			...prev,
			[key] : !prev[key]
		}));
	};

	useEffect(() =>
	{
		if (callDetails?.status === 'connected')
		{
			const interval = setInterval(() =>
			{
				setDuration((prevSeconds) => prevSeconds + 1);
			}, 1000);

			return () => clearInterval(interval);
		}
	}, [ callDetails?.status ]);

	const handleCallCancel = async () =>
	{
		if (callDetails?.type === PRESENCE_ENUMS.individual)
		{
			updateCallDetails(callDetails?.initiator === userData?.userId ? PRESENCE_ENUMS.missed : PRESENCE_ENUMS.declined, null, callDetails);
		}
		else if (callDetails?.type === PRESENCE_ENUMS.group)
		{
			dispatch(setEachCallDetailChanges({ status: PRESENCE_ENUMS.declined, groupId: callDetails?.groupId, callId: callDetails?.callId }));
			setUpGroupCallInfo('declined', callDetails);
		}
		dispatch(setVideoCall(''));
		peerConnectionClose(callDetails?.callId);
	};

	const handleEndCall = async () =>
	{
		if (screenStreamRef.current)
		{
			screenStreamRef.current.getTracks().forEach((track) => track.stop());
			screenStreamRef.current = null;
		}
		updateCallDetails(PRESENCE_ENUMS.ended, duration, callDetails);
		dispatch(setRoomModeView('democratic'));
		peerConnectionClose(callDetails?.callId);
		if (callData?.videoCall === PRESENCE_ENUMS.onGoing)
		{
			dispatch(setVideoCall(''));
		}
	};

	const handleAnswerCall = () =>
	{
		handleAccept();
	};

	// this is for only showing instant slef vedio
	useEffect(() =>
	{
		navigator.mediaDevices.getUserMedia({ video: true, audio: false })
			.then((stream) =>
			{
				temporaryRef.current = stream;

				if (remoteVideoStreemRef.current)
				{
					remoteVideoStreemRef.current.srcObject = stream;
				}
			})
			.catch((error) => console.error('Error accessing webcam:', error));

		return () =>
		{
			console.log('close=================>', temporaryRef.current, localStreamRef, remoteStreamRef);
			if (temporaryRef.current)
			{
				temporaryRef.current.getTracks().forEach((track) => track.stop());
				temporaryRef.current = null;
			}
			if (screenStreamRef.current)
			{
				screenStreamRef.current.getTracks().forEach((track) => track.stop());
				screenStreamRef.current = null;
			}
			if (localStreamRef)
			{
				localStreamRef.getTracks().forEach((track) => track.stop());
			}
			if (remoteStreamRef)
			{
				remoteStreamRef.getTracks().forEach((track) => track.stop());
			}
		};
	}, []);

	useEffect(() =>
	{
		if (localVideoStreemRef.current && callDetails?.status === 'connected' && !max)
		{
			localVideoStreemRef.current.srcObject = localStreamRef;
		}

		if (remoteVideoStreemRef.current && callDetails?.status === 'connected' && !max)
		{
			remoteVideoStreemRef.current.srcObject = remoteStreamRef;
		}
	}, [ localStreamRef, remoteStreamRef, callDetails?.status, max ]);

	const updateMicAndCam = (type, status) =>
	{
		if (type === 'audio')
		{
			handleAudioOff(status);
		}
		if (type === 'video')
		{
			updateCallCamera(status);
			if (temporaryRef.current)
			{
				temporaryRef.current?.getVideoTracks().forEach((track) =>
				{
					track.stop();
					temporaryRef.current?.removeTrack(track);
				});
			}
		}
	};

	const handleStartSharing = async (screenStream) =>
	{
		const screenVideoTrack = screenStream.getVideoTracks()[0];

		if (!screenVideoTrack)
		{
			console.error('No screen video track found.');

			return;
		}

		// Find the video sender if it exists
		const videoSender = pc.getSenders().find((sender) => sender.track?.kind === 'video');

		if (videoSender)
		{
			console.log('Replacing video sender track with screen track');
			// If a video sender exists, replace the track
			videoSender.replaceTrack(screenVideoTrack);
		}

		if (localStreamRef)
		{
			localStreamRef.srcObject = screenStream;
		}

		// Update Firestore and Redux call details
		await updateDocByDocumentId('messages', callDetails?.callId, {
			callDetails : { ...callDetails, screenShareId: userData?.userId }
		});
		dispatch(setCallDetails({ ...callDetails, screenShareId: userData?.userId }));
	};

	const handleStopSharing = async () =>
	{
		if (!screenStreamRef.current) return;

		// Stop the screen share tracks
		screenStreamRef.current.getTracks().forEach((track) => track.stop());

		screenStreamRef.current = null;

		if (originalStreamRef.current)
		{
			const originalVideoTrack = originalStreamRef.current.getVideoTracks()[0];

			// Replace the screen share track with the original video track
			pc.getSenders().forEach((sender) =>
			{
				if (sender.track.kind === 'video')
				{
					sender.replaceTrack(originalVideoTrack);
				}
			});

			// Optionally update local stream UI
			if (localStreamRef)
			{
				localStreamRef.srcObject = originalStreamRef.current;
			}
			screenStreamRef.current = null;
		}
		const callDtls:object = store.getState().mypresence.callDetails ?? {};

		// Update Firestore and Redux call details
		await updateDocByDocumentId('messages', callDetails?.callId, {
			callDetails : { ...callDtls, screenShareId: '' }
		});
		dispatch(setCallDetails({ ...callDtls, screenShareId: '' }));
		dispatch(setRoomModeView('democratic'));
	};

	const handleScreenShare = async () =>
	{
		if (userData?.userId !== callDetails?.screenShareId && callData?.roomModeView === 'screenShare')
		{
			toast.dismiss();
			toast.error(`${callDetails?.participants[callDetails?.screenShareId]?.name || 'Someone'} is already sharing their screen`);

			return;
		}

		if (callData?.roomModeView === 'democratic')
		{
			try
			{
				const screenShareConstraints = {
					cursor         : config?.cursor, // Ensures cursor visibility
					displaySurface : config?.displaySurface, // Capture full display
					frameRate      : config?.screenShareFrameRate, // Smooth frame rate for screen share
					height         : config?.screenShareHeight, // Full HD resolution
					width          : config?.screenShareWidth
				};

				const screenStream = await navigator.mediaDevices.getDisplayMedia({
					video : screenShareConstraints
				});

				const currentCallDetails:any = store.getState()?.mypresence?.callDetails;

				if (screenStream && (Object.values(currentCallDetails)?.length === 0 || currentCallDetails?.status === 'ended'))
				{
					screenStream.getTracks().forEach((track) => track.stop());
					toast.dismiss();
					toast.warn('Oops! This call is no longer active.');

					return;
				}
				if (screenStream && currentCallDetails?.screenShareId)
				{
					screenStream.getTracks().forEach((track) => track.stop());
					toast.dismiss();
					toast.error(`${currentCallDetails?.participants[currentCallDetails?.screenShareId]?.name || 'Someone'} is already sharing the screen`);

					return;
				}
				// Store the original video track (if exists) before replacing it

				if (localStreamRef.getVideoTracks().length > 0)
				{
					const videoTrack = localStreamRef.getVideoTracks()[0];

					originalStreamRef.current = new MediaStream([ videoTrack ]);
				}

				const screenShareTrack = screenStream?.getVideoTracks()[0];

				// Listen for the end of the screen share
				screenShareTrack.onended = () =>
				{
					handleStopSharing();
					console.log('ended=======================================================');
				};

				// Set the screen stream and start sharing
				screenStreamRef.current = screenStream;

				handleStartSharing(screenStreamRef.current);
			}
			catch (error)
			{
				console.error('Error sharing screen: ', error);
				handleStopSharing();
			}
		}
		else
		{
			handleStopSharing();
		}
	};

	const getCallStatus = () =>
	{
		const status = callDetails?.type === 'group' ? callDetails?.participants[userData?.userId]?.status : callDetails?.status;

		switch (status)
		{
			case 'connected':
				return language?.ongoing;
			case 'accepted':
				return 'connecting';
			case 'ringing':
				return language?.ringing;
			case 'connecting':
				return language?.calling;
			default:
				return callData?.audioCall === PRESENCE_ENUMS.incoming ? language?.incoming : callData?.audioCall === PRESENCE_ENUMS.initiated ? language?.calling : language?.ringing;
		}
	};

	const callerData:any = callDetails && Object.values(callDetails?.participants)?.find((i:any) => i?.id !== userData?.userId);
	const selfData:any = callDetails && Object.values(callDetails?.participants)?.find((i:any) => i?.id === userData?.userId);
	const initiatorData:any = callDetails?.type === 'group' && callDetails?.initiator
		? Object.values(callDetails?.participants || {})?.find((i:any) => i?.id === callDetails?.initiator)
		: null;

	const getImageUrl = useCallback((participantData:any) =>
	{
		if (callDetails?.type === 'group' && callDetails?.groupIcon)
		{
			return callDetails?.groupIcon;
		}

		if (callDetails?.type === PRESENCE_ENUMS.individual)
		{
			// If participant has an ID, try S3 URL pattern
			if (participantData?.id)
			{
				return `${process.env.REACT_APP_S3_BASE_URL}/profile/${participantData?.id}_profile.jpeg?t=${Date.now().valueOf()}`;
			}
			else
			{
				return selfData?.profileImg;
			}
		}
	}, [ callDetails?.type, callDetails?.groupIcon, selfData?.profileImg ]);

	const callerImageRef = useRef<string>(getImageUrl(callerData));
	const selfImageRef = useRef<string>(getImageUrl(selfData));

	const handleErrorImage = (type) =>
	{
		if (type === 'caller')
		{
			callerImageRef.current = '/images/icons/defaultUser.svg';
		}
		else if (type === 'self')
		{
			selfImageRef.current = '/images/icons/defaultUser.svg';
		}
	};

	return (
		<Draggable
			onStart={() => handleDragState('start')}
			onStop={() => handleDragState('stop')}
			onDrag={() => handleDragState('drag')}
			bounds='parent'
		>
			{!max
				? (
					<Box
						sx={{
							position             : 'absolute',
							top                  : '30%',
							zIndex               : 1011,
							background           : 'rgba(35, 164, 196, 0.1)',
							borderRadius         : '13px',
							cursor               : 'grab',
							boxShadow            : '0px 4px 6px rgba(0,0,0,0.1)',
							backdropFilter       : 'blur(8px)',
							WebkitBackdropFilter : 'blur(8px)',
							display              : 'flex',
							flexDirection        : 'column',
							height               : '320px',
							width                : '250px',
							backgroundSize       : 'cover',
							backgroundRepeat     : 'no-repeat',
							right                : '25%',
							...(callData?.roomModeView === 'screenShare' && userData?.userId !== callDetails?.screenShareId && { aspectRatio: '16/9', width: 'auto' }),

							backgroundPosition       : 'center',
							'&:hover .hover-content' : {
								opacity    : 1,
								visibility : 'visible'
							}

						}}
					>
						{ [ PRESENCE_ENUMS.initiated, PRESENCE_ENUMS.incoming, PRESENCE_ENUMS.outGoing ].includes(callData?.videoCall) && <audio autoPlay hidden preload='auto' loop>
							<source
								src={callData?.audioCall === PRESENCE_ENUMS.incoming ? '/audio/ringone.mp3' : '/audio/ringone.mp3'}
								type='audio/mpeg'
							/>
							Your browser does not support the audio element.
						</audio>}
						{callerData?.isVideoPaused &&
						<img
							src={callerImageRef?.current || '/images/icons/defaultUser.svg'}
							alt='profile'
							draggable={false}
							style={{
								position   : 'absolute',
								top        : 0,
								left       : 0,
								width      : '100%',
								height     : '100%',
								objectFit  : 'contain',
								zIndex     : -1, // Ensure video stays in the background
								opacity    : (callerData?.isVideoPaused && callData?.roomModeView !== 'screenShare') ? 1 : 0, // Hide when video is playing
								transition : 'opacity 0.3s ease-in-out' // Smooth transition effect
							}}
							onError={() => handleErrorImage('caller')}
						/>
						}
						<video
							ref={remoteVideoStreemRef}
							playsInline
							autoPlay
							muted
							loop
							style={{
								position   : 'absolute',
								top        : 0,
								left       : 0,
								width      : '100%',
								height     : '100%',
								objectFit  : 'contain',
								zIndex     : -1, // Ensure video stays in the background
								opacity    : (callerData?.isVideoPaused && callData?.roomModeView !== 'screenShare') ? 0 : 1, // Hide when paused
								transition : 'opacity 0.3s ease-in-out', // Smooth transition effect
								transform  : callDetails?.screenShareId ? 'scaleX(1)' : 'scaleX(-1)'
							}}
						/>
						<Box
							alignItems='center'
							display='flex'
							className='hover-content'
							sx={{
								bgcolor      : onGoingCall ? '#90D89F' : '',
								p            : 1,
								borderRadius : '13px 13px 0 0 ',
								opacity      : onGoingCall ? 0 : 1,
								visibility   : onGoingCall ? 'hidden' : 'visible',
								transition   : 'opacity 0.3s ease, visibility 0.3s ease',
								overflow     : 'hidden'
							}}
						>
							<Stack
								direction='row'
								justifyContent={onGoingCall ? 'space-between' : 'flex-end'}
								width='100%'
							>
								{duration > 0 &&
								<Typography variant='inherit' fontSize={16}>
									{callTimerFormat(duration)}
								</Typography>
								}

								{onGoingCall && <LuMaximize fontSize={18} onClick={handleMaxScreen} color={onGoingCall ? '#000' : '#fff'} style={{ cursor: 'pointer' }} />}
							</Stack>
						</Box>
						<Stack
							direction='column'
							spacing={1}
							alignItems='center'
							flexGrow={1}
							p={2}
							className='hover-content'
							sx={{
								opacity    : onGoingCall ? 0 : 1,
								visibility : onGoingCall ? 'hidden' : 'visible',
								transition : 'opacity 0.3s ease, visibility 0.3s ease'
							}}
						>
							<Typography variant='inherit' fontSize={20} fontWeight={500} color='#fff'
								sx={{
									display      : 'inline-block',
									whiteSpace   : 'nowrap',
									overflow     : 'hidden',
									textOverflow : 'ellipsis',
									width        : '100%',
									textAlign    : 'center'
								}}
							>
								{callDetails?.type === 'group' ? (callDetails?.groupName || language?.groupCall) : callerData?.name ?? ''}
							</Typography>
							{callDetails?.type === 'group' && initiatorData && callDetails?.initiator !== userData?.userId && (
								<Typography variant='inherit' fontSize={14} fontWeight={400} color='rgba(255,255,255,0.7)'
									sx={{
										display      : 'inline-block',
										whiteSpace   : 'nowrap',
										overflow     : 'hidden',
										textOverflow : 'ellipsis',
										width        : '100%',
										textAlign    : 'center',
										mt           : 0
									}}
								>
									{`${language?.groupCall || 'Group call'} by ${initiatorData?.name || 'Unknown'}`}
								</Typography>
							)}
							{(callDetails?.status !== 'connected' || reconectionRef) &&
							<Stack direction='row' spacing={0.5} alignItems='baseline' lineHeight={0}>
								<Typography variant='inherit' color='#fff'>
									{reconectionRef ? 'Reconectig' : getCallStatus()}
								</Typography>
								<Stack direction='row' spacing={0.5}>
									{Array.from({ length: dotCount }).map((_, index) => (
										<Stack key={index}>
											<Typography className='dots' style={{ animationDelay: `${index * 0.3}s`, backgroundColor: '#fff' }} />
										</Stack>
									))}
								</Stack>
							</Stack>
							}
						</Stack>
						{callDetails?.status === 'connected' &&
						<Box
							height={80}
							width={80}
							borderRadius='13px'
							sx={{
								overflow : 'hidden',
								display  : callDetails?.status !== 'connected' ? 'none' : '',
								position : 'relative'
							}}
							mx={1}
						>
							<video
								ref={localVideoStreemRef}
								autoPlay
								muted
								playsInline
								style={{
									borderRadius : '13px',
									height       : '100%',
									width        : '100%',
									objectFit    : 'cover',
									opacity      : selfData?.isVideoPaused ? 0 : 1,
									transition   : 'opacity 0.3s ease-in-out',
									transform    : 'scaleX(-1)'
								}}
							/>
							{selfData?.isVideoPaused &&
							<img
								src={selfImageRef.current || '/images/icons/defaultUser.svg'}
								alt='profile'
								style={{
									position     : 'absolute',
									top          : 0,
									left         : 0,
									borderRadius : '13px',
									width        : '100%',
									height       : '100%',
									objectFit    : 'cover',
									opacity      : selfData?.isVideoPaused ? 1 : 0,
									transition   : 'opacity 0.3s ease-in-out'
								}}
								onError={() => handleErrorImage('self')}
							/>}
						</Box>}
						{callData?.videoCall === PRESENCE_ENUMS.incoming && callDetails?.initiator !== userData?.userId
							?	(
								<Stack
									p={1}
									paddingTop={0}
									direction='row'
									spacing={2}
									width='100%'
									justifyContent='space-around'
								>
									<IconButton
										sx={{
											backgroundColor : '#007519',
											color           : '#fff',
											'&:hover'       : { backgroundColor: '#007519' },
											'&:active'      : { backgroundColor: '#007519' }
										}}
										onTouchStart={handleAnswerCall} onClick={handleAnswerCall}
									>
										<MdOutlineVideocam fontSize={22} />
									</IconButton>

									<IconButton
										sx={{
											backgroundColor : '#FF6767',
											color           : '#fff',
											'&:hover'       : { backgroundColor: '#FF6767' },
											'&:active'      : { backgroundColor: '#FF6767' }
										}}
										onTouchStart={handleCallCancel} onClick={handleCallCancel}
									>
										<MdCallEnd fontSize={22} />
									</IconButton>
								</Stack>
							)
							: (
								<Box alignItems='center' display='flex' p={1}
									className='hover-content'
									sx={{
										opacity    : onGoingCall ? 0 : 1,
										visibility : onGoingCall ? 'hidden' : 'visible',
										transition : 'opacity 0.3s ease, visibility 0.3s ease'
									}}
								>
									<Stack
										p={1}
										direction='row'
										spacing={1}
										width='100%'
										justifyContent='center'
									>
										{onGoingCall &&
										<IconButton
											onTouchStart={() => updateMicAndCam('video', !callData?.webcamInProgress)}
											onClick={() => updateMicAndCam('video', !callData?.webcamInProgress)}
											disabled={userData?.userId === callDetails?.screenShareId}
										>
											{!callData?.webcamInProgress
												? <MdVideocamOff fontSize={22} color='#fff'/>
												: <MdVideocam fontSize={22} color='#fff'/>}
										</IconButton>
										}
										{onGoingCall &&
										<IconButton onTouchStart={() => updateMicAndCam('audio', !callData?.audioInProgress)} onClick={() => updateMicAndCam('audio', !callData?.audioInProgress)}>
											{!callData?.audioInProgress
												? <IoMdMicOff fontSize={22} color='fff' />
												: <IoMdMic fontSize={22} color='fff' />}
										</IconButton>
										}
										{onGoingCall &&
										<IconButton onTouchStart={handleScreenShare} onClick={handleScreenShare}>
											<MdScreenShare fontSize={22} color='fff'/>
										</IconButton>
										}
										<IconButton onTouchStart={() => (callData?.videoCall === PRESENCE_ENUMS.onGoing ? handleEndCall() : handleCallCancel())} onClick={() => (callData?.videoCall === PRESENCE_ENUMS.onGoing ? handleEndCall() : handleCallCancel())}>
											<MdCallEnd fontSize={22} color='#FF6767' />
										</IconButton>
										{/* <IconButton onClick={handleMenu} >
									<MdMoreVert fontSize={22} color='fff'/>
								</IconButton> */}

									</Stack>
								</Box>
							)
						}
					</Box>
				)
				: (
					<FullScreen
						handleMaxScreen={handleMaxScreen}
						handleEndCall={handleEndCall}
						duration={duration}
						callType='video'
						callerData={callerData}
						handleScreenShare={handleScreenShare}
						updateCamera={updateMicAndCam}
						localStream={localStreamRef}
						remoteStream={remoteStreamRef}
						screenStreamRef={screenStreamRef}
						reconectionRef={reconectionRef}
					/>
				)}
		</Draggable>
	);
};

export default PeerToPeerCall;
